import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import TranslationsMenu from '../components/translations/TranslationsMenu.vue';
import TranslationsList from '../components/translations/TranslationsList.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'TranslationsView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TranslationsMenu),
    _createVNode(TranslationsList)
  ], 64))
}
}

})